import axios from 'axios';

import {
    CompanyPrivacyConfigRequest,
    CompanyPrivacyConfigResponse,
    SaveCompanyPrivacyConfigRequest,
    SaveCompanyPrivacyConfigResponse
} from '../schemas';

function authHeaders() {
    return {
        Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
    };
}

// Active configs only - used by the banner/footer
export async function getAll(
    params?: CompanyPrivacyConfigRequest,
    signal?: AbortSignal
) {
    return axios.get<CompanyPrivacyConfigResponse>('/v1/company/privacy_config', {
        params,
        signal,
        headers: authHeaders()
    });
}

// Config of one company regardless of is_active - requires admin of that company
export async function getForManage(sid: string) {
    return axios.get<CompanyPrivacyConfigResponse>('/v1/company/privacy_config/manage', {
        params: { sid },
        headers: authHeaders()
    });
}

export async function save(body: SaveCompanyPrivacyConfigRequest) {
    return axios.post<SaveCompanyPrivacyConfigResponse>('/v1/company/privacy_config', body, {
        headers: authHeaders()
    });
}
